import { validateOptionalAlphanumericTrim } from './AlphanumericValidate'

export const PROVIDER_NUMBER_INVALID_MESSAGE = 'Please type a valid provider number'

export const validateOptionalProviderNumberTrim = (providerNumber?: string): true | string =>
  validateOptionalAlphanumericTrim(providerNumber, PROVIDER_NUMBER_INVALID_MESSAGE)
